import { MutationTree } from "vuex";
import { IDataProvider } from "@/store";
import {
  INotification,
  INotificationState,
  IProcessInfoNotification,
} from "@/store/modules/notification/state";
import { NotificationGetters } from "@/store/modules/notification/getters";

export enum NotificationMutations {
  CHANGE_NOTIFICATION_COUNT = "CHANGE_NOTIFICATION_COUNT",
  CHANGE_PROCESS_INFO_NOTIFICATION = "CHANGE_PROCESS_INFO_NOTIFICATION",
  CHANGE_PROCESS_INFO_NOTIFICATIONS = "CHANGE_PROCESS_INFO_NOTIFICATIONS",
  SET_ONE = "SET_ONE_NOTIFICATION",
  SET_ALL = "SET_ALL_NOTIFICATION",
  SET_LAZY_DATA = "SET_LAZY_DATA_NOTIFICATION",
}

export const mutations: MutationTree<INotificationState> = {
  [NotificationMutations.SET_ONE](state, payload: INotification) {
    state.notification = payload;
  },
  [NotificationMutations.SET_ALL](state, payload: INotification[]) {
    state.notifications = payload;
  },
  [NotificationMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<INotification>
  ) {
    state.dataProvider = payload;
  },
  [NotificationMutations.CHANGE_NOTIFICATION_COUNT](state, payload) {
    state.count = payload;
    state.countRevision++;
  },
  [NotificationMutations.CHANGE_PROCESS_INFO_NOTIFICATION](
    state,
    payload: any
  ) {
    state.processInfoRevision++;
    const notification = state.processInfoNotifications.find(
      (item) => item.templateId === payload.templateId
    );
    if (notification) {
      if (payload.changeType === "INCREASE") {
        notification.count++;
      } else if (payload.changeType === "DECREASE") {
        notification.count = Math.max(0, notification.count - 1);
      }
    } else {
      state.processInfoNotifications.push({
        templateId: payload.templateId,
        count: payload.changeType === "DECREASE" ? 0 : 1,
      });
    }
  },
  [NotificationMutations.CHANGE_PROCESS_INFO_NOTIFICATIONS](
    state,
    payload: IProcessInfoNotification[] | null
  ) {
    state.processInfoNotifications = payload ?? [];
    state.processInfoRevision++;
  },
};
